import Vue from 'vue';
import Router from 'vue-router';
import index from '../page/index/index';
import chongindex from '../page/index/chongindex';
import finished from '../page/index/finished';
import login from '../page/login/login';
import externalLink from '../page/index/externalLink';
import firstEntry from '../page/index/firstEntry.vue';
import orgRankState from '../page/ownerEvaluation/orgRankState/orgRankState';//物业排名路由 ，无需登录
import externalLinks from '../page/index/externalLinks';  //物业排名路由 ，无需登录
import ownerEvaluationLists from '../page/index/ownerEvaluationLists';  //物业排名路由 ，无需登录
import PropertyProjectList from '../page/index/PropertyProjectList.vue';//物业项目路由 ，无需登录
import DetailedCellRanking from '../page/index/DetailedCellRanking.vue';//具体小区路由 ，无需登录
import OwnerCertificate from '../page/index/OwnerCertificate';  //业主大会统一社会信用代码证书路由 ，无需登录

import PropertyProjectInformationInquiryList from '../page/PublicInformationInquiry/PropertyProjectInformationInquiry/PropertyProjectInformationInquiryList';
import PropertyProjectInformationDetailList from '../page/PublicInformationInquiry/PropertyProjectInformationInquiry/PropertyProjectInformationDetailList';
import EmployeeInformationInquiryList from '../page/PublicInformationInquiry/EmployeeInformationInquiry/EmployeeInformationInquiryList';
import PropertyProjectManagerDetails from '../page/PublicInformationInquiry/PropertyProjectManager/PropertyProjectManagerDetails';
import InformationInquiryPropertyEnterprisesList from '../page/PublicInformationInquiry/InformationInquiryPropertyEnterprises/InformationInquiryPropertyEnterprisesList';
import InformationDetailPropertyEnterprisesList from '../page/PublicInformationInquiry/InformationInquiryPropertyEnterprises/InformationDetailPropertyEnterprisesList';
import GeneralMeetingOfProprietorsList from '../page/PublicInformationInquiry/GeneralMeetingOfProprietors/GeneralMeetingOfProprietorsList.vue';
import GeneralMeetingOfProprietorsDetailList from '../page/PublicInformationInquiry/GeneralMeetingOfProprietors/GeneralMeetingOfProprietorsDetailList.vue';

import InformationCompany from '../page/PubilcCreditinformation/InformationCompany';
import toGis from '../page/toGis/toGis';
import zhwyjgp from '../page/zhwyjgp/zhwyjgp';
import tosssbgl from '../page/rightMenu/tosssbgl/tosssbgl.vue';
import toWxjcgl from '../page/toWxjcgl/toWxjcgl.vue' //微信决策管理
import toZhwyDjyd from '../page/toZhwyDjyd/toZhwyDjyd.vue'
import toZhwy from '../page/toZhwy/toZhwy.vue';
import toZhwydjpt from '../page/toZhwydjpt/toZhwydjpt.vue'
import totoOwner from '../page/toOwner/totoOwner.vue';
import InformationManager from '../page/PubilcCreditinformation/InformationManager';
import PropInformation from '../page/PubilcCreditinformation/PropInformation';
import creditInformationDetail from '../page/PubilcCreditinformation/creditInformationDetail';
import comprehensiveList from '../page/PubilcCreditinformation/comprehensiveList';
import comprehensiveDetailsList from '../page/PubilcCreditinformation/comprehensiveDetailsList';
import evaluateDetail from '../page/PubilcCreditinformation/evaluateDetail'; // 评分详情
import overallEvaluation from '../page/PubilcCreditinformation/overallEvaluation'; // 业主评分详情

import wscsdl from '../page/wscsdl/wscsdl.vue';

import container from '../page/container/container';
import lose from '../page/httpCode/404/404';
import timeout from '../page/httpCode/500/500';
import propertyAreaMgeRouter from './modules/propertyAreaMgeRouter';
import logindexRouter from './modules/logindexRouter';
import organMgeRouter from './modules/organMgeRouter';
import businessOrderDetailRouter from './modules/businessOrderDetail';

import disputeResolutionRouterFile from './modules/disputeResolution';
import SolicitationOfOpinionsRouer from './modules/SolicitationOfOpinionsRouer';
import ownersAssemblyRecordRouter from './modules/ownersAssemblyRecordRouter';
import voteRouter from './modules/voteRouter';
import propertyMgeRouter from './modules/propertyMgeRouter';
import expertInfoView from './modules/expertInfo';
import complaintMgeRouter from './modules/complaintMgeRouter';
import equipmentAdministrationRouter from './modules/equipmentAdministration';
import inspectionAndEvaMgeRouter from './modules/inspectionAndEvaMgeRouter';
import satisfactionSurveyRouter from './modules/satisfactionSurveyRouter';
import committeeRecordRouter from './modules/committeeRecordRouter'; //05-23放出
import industryCouncilRouter from './modules/industryCouncilRouter'; //05-23放出
import PersonalCenterRouter from './modules/PersonalCenterRouter';
import systemRouter from './modules/systemRouter';
import mineRouter from './modules/mineRouter';
import messageListRouter from './modules/messageListRouter';
import realtyMgeRouter from './modules/realtyMgeRouter';
import demoRouter from './modules/demoRouter';
import newsFeedRouter from './modules/newsFeedRouter';
import noticeRouter from './modules/noticeRouter';
import knowledgeBaseRouter from './modules/knowledgeBaseRouter';
// import searchRouter from './modules/searchRouter';
import SafeProductionRouter from './modules/SafeProductionRouter';
import safetyDetailsRouter from './modules/safetyDetailsRouter';
import HonestyProvinceRouter from './modules/HonestyProvinceRouter';
import ownerEvaluationRouter from './modules/ownerEvaluationRouter';
import reportsmgeRouter from './modules/reportsmgeRouter';
import PublicInformationInquiryRouter from './modules/PublicInformationInquiryRouter';
import publicitytrainingRouter from './modules/publicitytrainingRouter';//宣传统计
import lettersRegulatorsRouter from './modules/lettersRegulatorsRouter';
import creditArchivesRouter from './modules/creditArchivesRouter';
import propertyReportRouter from './modules/propertyReportRouter'; //企业报表管理
import comprehensiveInquireRouter from './modules/comprehensiveInquireRouter'; //信息综合查询
import enterpriseBackupInformationRouter from './modules/enterpriseBackupInformationRouter';//企业备用信息查询
import appeaReportRouter from './modules/appeaReportRouter'; //报表上报
//import contractRouter from './modules/contractRouter'; //合同
import StatisticalSearchRouter from './modules/StatisticalSearchRouter';
import workFlowMgeRouter from './modules/workFlowMgeRouter';
import adminiRouter from './modules/adminiRouter';
import accountRouter from './modules/accountRouter';// 共有资金
// import rightsRouter from './modules/rightsRouter';// 权限管理
import downLoadUpLoadRouter from './modules/downLoadUpLoad';// 上传文件空白页面
import supplementaryRouter from './modules/supplementaryRouter';// 物业备案数据补录
import creditEvaluationRouter from './modules/creditEvaluationRouter';// 信用评价 
import officialWebsitePublicityRouter from './modules/officialWebsitePublicityRouter';// 官网评价公示
import creditEvaluationPublicityRouter from './modules/creditEvaluationPublicityRouter';// 平台评价公示
import StatisticsParkingRouter from './modules/StatisticsParkingRouter';// 停车位统计
import InformationOfPractitionersRouter from './modules/InformationOfPractitionersRouter';// 从业人员统计
import greenPropertyRouter from './modules/greenPropertyRouter';// 绿色物业
import projectCompanyDetailListRouter from './modules/projectCompanyDetailListRouter';// 在管物业项目及企业明细表
import companyInfoConfirmRouter from './modules/companyInfoConfirmRouter';// 企业信息确认
import examinelistRouter from './modules/experDabaseRouter'; //专家库
import statisticsRouter from './modules/statisticsRouter';// 统计模块
import policiesindexRouter from './modules/policiesRouter';
import previewRouter from './modules/previewRouter';
import projectWhiteListRouter from './modules/projectWhiteListRouter';
import allowancesRouter from './modules/allowancesRouter';
import totoOwnerRouter from './modules/totoOwnerRouter';
import helpMegRouter from './modules/helpMegRouter';
import toZhwyRouter from './modules/toZhwyRouter';
import unemployedRouter from './modules/unemployedRouter';

// 纠纷化解台账
import disputeResolution from './modules/disputeResolution';
import enterpiseInfoRegisterRouter from './modules/enterpiseInfoRegisterRouter'; // 企业信息登记

import enterpriseProjectRouter from './modules/enterpriseProjectRouter';
// 项目单位名录

//需求管理
import demandMgeRouter from './modules/demandMgeRouter';

import tenantRouter from './modules/tenantRouter';

//分级分类
import gradeClassifyRouter from'./modules/gradeClassifyRouter'

import toZhwyDjRouter from './modules/toZhwyDjpt';
// 规上企业经济指标填报
import fillEconomicIndicatorsRouter from './modules/fillEconomicIndicatorsRouter';


Vue.use(Router);



export const constantRouterMap = [{
  path: '',
  redirect: '/index',
  name: '首页',
  meta: {
    title: '首页'
  },
},
{
  path: '',
  component: container,
  children: [{
    path: '/index',
    component: index,
    name: '首页'
  }],
},
{
  path: '/login',
  name: 'login',
  component: login
},
{
  path: '/chongindex',
  name: 'chongindex',
  component: chongindex
},
{
  path: '/finished',
  name: 'finished',
  component: finished
},
{
  path: '/wscsdl',
  name: 'wscsdl',
  component: wscsdl
},
{
  path: '/externalLink',
  name: 'externalLink',
  component: externalLink
},
{
  path: '/firstEntry',
  name: 'firstEntry',
  component: firstEntry,
},
{
  path: '/orgRankState',
  name: 'orgRankState',
  component: orgRankState
},
{
  path: '/toGis',
  name: 'toGis',
  component: toGis
},
{
  path: '/zhwyjgp',
  name: 'zhwyjgp',
  component: zhwyjgp
},
{
  path: '/tosssbgl',
  name: 'tosssbgl',
  component: tosssbgl
},
{
  path: '/toWxjcgl',
  name: 'toWxjcgl',
  component: toWxjcgl
},
{
  path: '/toZhwyDjyd',
  name: 'toZhwyDjyd',
  component: toZhwyDjyd
},
{
  path: '/totoOwner',
  name: 'totoOwner',
  component: totoOwner
},
// {
//   path: '/toZhwy',
//   name: 'toZhwy',
//   component: toZhwy
// },
{
  path: '/toZhwy',
  name: 'toZhwy',
  component: toZhwy
},
{
  path: '/toZhwydjpt',
  name: 'toZhwydjpt',
  component: toZhwydjpt
},
{
  path: '/externalLinks',
  name: 'externalLinks',
  component: externalLinks
},
{
  path: '/OwnerCertificate',
  name: 'OwnerCertificate',
  component: OwnerCertificate
},

{
  path: '/ownerEvaluationLists',
  name: 'ownerEvaluationLists',
  component: ownerEvaluationLists
},

{
  path: '/PropertyProjectList',
  name: 'PropertyProjectList',
  component: PropertyProjectList
},
{
  path: '/DetailedCellRanking',
  name: 'DetailedCellRanking',
  component: DetailedCellRanking
},
//////////////
{
  path: '/PropertyProjectInformationInquiryList',
  name: 'PropertyProjectInformationInquiryList',
  component: PropertyProjectInformationInquiryList
},
{
  path: '/PropertyProjectInformationDetailList',
  name: 'PropertyProjectInformationDetailList',
  component: PropertyProjectInformationDetailList
},//
{
  path: '/EmployeeInformationInquiryList',
  name: 'EmployeeInformationInquiryList',
  component: EmployeeInformationInquiryList
},
{
  path: '/PropertyProjectManagerDetails',
  name: 'PropertyProjectManagerDetails',
  component: PropertyProjectManagerDetails
},
{
  path: '/InformationInquiryPropertyEnterprisesList',
  name: 'InformationInquiryPropertyEnterprisesList',
  component: InformationInquiryPropertyEnterprisesList
},
{
  path: '/InformationDetailPropertyEnterprisesList',
  name: 'InformationDetailPropertyEnterprisesList',
  component: InformationDetailPropertyEnterprisesList
},
{
  path: '/GeneralMeetingOfProprietorsList',
  name: 'GeneralMeetingOfProprietorsList',
  component: GeneralMeetingOfProprietorsList
},
{
  path: '/GeneralMeetingOfProprietorsDetailList',
  name: 'GeneralMeetingOfProprietorsDetailList',
  component: GeneralMeetingOfProprietorsDetailList
},
{
  path: '/InformationCompany',
  name: 'InformationCompany',
  component: InformationCompany
},
{
  path: '/PropInformation',
  name: 'PropInformation',
  component: PropInformation
},
{
  path: '/InformationManager',
  name: 'InformationManager',
  component: InformationManager
},
{
  path: '/creditInformationDetail',
  name: 'creditInformationDetail',
  component: creditInformationDetail
},
{
  path: '/comprehensiveList',
  name: 'comprehensiveList',
  component: comprehensiveList
},
{
  path: '/evaluateDetail',
  name: 'evaluateDetail',
  component: evaluateDetail
},
{
  path: '/overallEvaluation',
  name: 'overallEvaluation',
  component: overallEvaluation
},
{
  path: '/comprehensiveDetailsList',
  name: 'comprehensiveDetailsList',
  component: comprehensiveDetailsList
},
...officialWebsitePublicityRouter,
/////////////////
{
  path: '/404',
  name: '404',
  component: lose
},
{
  path: '/500',
  name: '500',
  component: timeout
}
];
export const asyncRouterMap = [{
  path: '',
  component: container,
  children: [
    SolicitationOfOpinionsRouer,//意见征集
    enterpiseInfoRegisterRouter, // 企业信息登记
    disputeResolutionRouterFile,
    organMgeRouter,
    propertyMgeRouter,
    satisfactionSurveyRouter,
    propertyAreaMgeRouter,
    expertInfoView,
    logindexRouter,
    policiesindexRouter,
    previewRouter,
    equipmentAdministrationRouter,
    // industryCommitteeRecordRouter, //多余 可删除
    ownersAssemblyRecordRouter,
    StatisticsParkingRouter,
    InformationOfPractitionersRouter,
    greenPropertyRouter,
    statisticsRouter,
    
    // developmentConstructionRouter,//05-23放出
    // publicFundManagementRouter,
    // voteAnalysisRouter,
    // propertyManagementPersonnelRouter,//05-23放出
    complaintMgeRouter,
    helpMegRouter,
    inspectionAndEvaMgeRouter,
    voteRouter,
    committeeRecordRouter, //05-23放出
    industryCouncilRouter, //05-23放出
    mineRouter,
    systemRouter,
    businessOrderDetailRouter,
    PersonalCenterRouter,
    messageListRouter,
    realtyMgeRouter,
    newsFeedRouter, //最新动态
    noticeRouter,
    // searchRouter,
    SafeProductionRouter,
    safetyDetailsRouter,
    HonestyProvinceRouter,
    ownerEvaluationRouter, //业主评价
    reportsmgeRouter, //报表
    PublicInformationInquiryRouter, //公共信息查询
    publicitytrainingRouter,//宣传统计
    lettersRegulatorsRouter, //信访工作监管
    creditArchivesRouter, // 诚信档案管理
    propertyReportRouter, //企业报表管理
    knowledgeBaseRouter, //行业知识库
    comprehensiveInquireRouter, //信息综合查询管理
    enterpriseBackupInformationRouter,// 企业备用信息查询
    appeaReportRouter, //报表上报
    //contractRouter, //合同
    StatisticalSearchRouter, //综合查询
    workFlowMgeRouter, //工作流管理
    adminiRouter,
    accountRouter,// 共有资金管理
    // rightsRouter,// 权限管理
    downLoadUpLoadRouter,
    supplementaryRouter, // 物业备案数据补录
    creditEvaluationRouter, // 信用评价
    // officialWebsitePublicityRouter, // 官网评价公示
    creditEvaluationPublicityRouter, // 平台评价公示
    projectCompanyDetailListRouter, // 在管物业项目及企业明细表
    projectWhiteListRouter, // 项目单位名录
    allowancesRouter,
    companyInfoConfirmRouter,
    examinelistRouter,
    totoOwnerRouter,
    // indexRouer,
    toZhwyRouter,
    unemployedRouter,
    disputeResolution,
    demoRouter,
    enterpriseProjectRouter,
    demandMgeRouter,
    tenantRouter,
    gradeClassifyRouter,
    toZhwyDjRouter,
    fillEconomicIndicatorsRouter
  ]
},
{
  path: '*',
  redirect: '/404',
  hidden: true
},
];

export const createRouter = () => {
  return new Router({
    base: process.env.BASE_URL,
    routes: constantRouterMap,
    ignoreDuplicates: true, //允许重复导航
  });
};
const router = createRouter();

export default router;
